// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

import App from './App.svelte';
import './i18n';

const app = new App({
  target: document.body,
  props: {
    name: 'KI-Assistent | Zusammenfassung',
  },
});

export default app;
